// Messages for operator/Account (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.account.head': 'Account — Operator',
  'operator.account.title': 'Your account',
  'operator.account.desc': 'Your personal profile and security.',
  'operator.account.profile': 'Profile',
  'operator.account.name': 'Display name',
  'operator.account.email': 'Email',
  'operator.account.email_locked': 'Contact an admin to change your email.',
  'operator.account.role': 'Role',
  'operator.account.save': 'Save',
  'operator.account.saved': 'Saved',
  'operator.account.password': 'Password',
  'operator.account.current_password': 'Current password',
  'operator.account.new_password': 'New password',
  'operator.account.confirm_password': 'Confirm new password',
  'operator.account.password_hint': 'At least 12 characters; can’t be a known-breached password.',
  'operator.account.update_password': 'Update password',
  'operator.account.password_updated': 'Password updated',
  'operator.account.security': 'Security',
  'operator.account.notifications': 'Notifications',
  'operator.account.notif_channels': 'Notification channels',
  'operator.account.notif_prefs': 'Event preferences',
  'operator.account.two_factor': 'Two-factor authentication',
  'operator.account.on': 'On',
  'operator.account.manage': 'Manage',
  'operator.account.set_up': 'Set up',
  'operator.account.active_sessions': 'Active sessions',
  'operator.account.device_one': '{count} device',
  'operator.account.device_other': '{count} devices',
  'operator.account.sign_in_identities': 'Linked sign-in',
  'operator.account.identity_one': '{count} identity',
  'operator.account.identity_other': '{count} identities',
}

export const zhTW = {
  'operator.account.head': '帳號 — 操作員',
  'operator.account.title': '您的帳號',
  'operator.account.desc': '您的個人資料與安全設定。',
  'operator.account.profile': '個人資料',
  'operator.account.name': '顯示名稱',
  'operator.account.email': '電子郵件',
  'operator.account.email_locked': '如需變更電子郵件，請聯絡管理員。',
  'operator.account.role': '角色',
  'operator.account.save': '儲存',
  'operator.account.saved': '已儲存',
  'operator.account.password': '密碼',
  'operator.account.current_password': '目前密碼',
  'operator.account.new_password': '新密碼',
  'operator.account.confirm_password': '確認新密碼',
  'operator.account.password_hint': '至少 12 個字元；不可為已外洩的常見密碼。',
  'operator.account.update_password': '更新密碼',
  'operator.account.password_updated': '密碼已更新',
  'operator.account.security': '安全',
  'operator.account.notifications': '通知',
  'operator.account.notif_channels': '通知管道',
  'operator.account.notif_prefs': '事件偏好',
  'operator.account.two_factor': '雙重驗證',
  'operator.account.on': '已啟用',
  'operator.account.manage': '管理',
  'operator.account.set_up': '設定',
  'operator.account.active_sessions': '使用中的工作階段',
  'operator.account.device_one': '{count} 個裝置',
  'operator.account.device_other': '{count} 個裝置',
  'operator.account.sign_in_identities': '已連結的登入',
  'operator.account.identity_one': '{count} 個身分',
  'operator.account.identity_other': '{count} 個身分',
}
